export default "__VITE_ASSET__DHbaJtP8__"